import { useCallback, type FC } from 'react';
import { useNursingHomeContext } from '@pflegenavi/frontend/nursing-home-context';
import { useNavigate } from 'react-router-dom';
import { nhAppMainPages } from '@pflegenavi/frontend/routing';
import { useClientStoredResourcesContext } from '@pflegenavi/frontend/client-stored-resources-context';
import { FM_IMPORT_STATE_LOCAL_STORAGE_KEY } from '@pflegenavi/shared/constants';
import {
  SelectNursingHomeView,
  type NursingHomeOption,
} from './SelectNursingHomeView';

export const SelectNursingHome: FC = () => {
  const navigate = useNavigate();
  const clientStoredResources = useClientStoredResourcesContext();

  const { selectedNursingHome, nursingHomeList: nursingHomes } =
    useNursingHomeContext();

  const handleSelectNursingHome = useCallback(
    (nursingHome: NursingHomeOption) => {
      navigate(
        nhAppMainPages.NURSING_HOME_SELECT.replace(
          ':nursingHomeId',
          nursingHome.id
        )
      );
      clientStoredResources.remove(FM_IMPORT_STATE_LOCAL_STORAGE_KEY);
    },
    [navigate, clientStoredResources]
  );

  // Don't render if data is not loaded or there's only one nursing home
  if (!nursingHomes || !selectedNursingHome || nursingHomes.length === 1) {
    return null;
  }

  return (
    <SelectNursingHomeView
      nursingHomes={nursingHomes}
      selectedNursingHome={selectedNursingHome}
      onSelectNursingHome={handleSelectNursingHome}
    />
  );
};
